import type { AssetVizLocaleConfig } from './AssetVizLocaleConfig'

/**
 * Default pass-through locale formatters. These provide functional (if basic)
 * output without a host locale provider. Measurements are formatted as
 * raw numeric values via toString(), and axis names use generic defaults.
 */
export const defaultLocaleConfig: AssetVizLocaleConfig = {
  formatMeasurement: ({ measurement, showLoading }) => {
    if (!measurement) return undefined
    if (showLoading) return 'Loading...'
    if (Number.isNaN(measurement.num)) return '...'
    return measurement.toString()
  },

  formatMeasurementRange: ({ measurement, showLoading }) => {
    if (!measurement) return undefined
    if (showLoading) return 'Loading...'
    const startStr = Number.isNaN(measurement.start.num)
      ? '...'
      : measurement.start.toString()
    const endStr = Number.isNaN(measurement.end.num)
      ? '...'
      : measurement.end.toString()
    return `${startStr} - ${endStr}`
  },

  formatRange: ({ start, end, inputUnit }) =>
    `${start} - ${end} ${String(inputUnit)}`,

  getPreferredMeasurementUnit: (inputUnit) => inputUnit,

  getAxisNames: () => ({ xAxisName: 'Position', yAxisName: 'Elevation' }),
}
